import React from 'react';
import styles from './modal_confirmation_header_no_close.module.scss';

type Props = {
  title: string | React.ReactNode;
};

export const ModalConfirmationHeaderNoClose: React.FC<Props> = ({ title }) => (
  <>
    <div className={styles.title}>{title}</div>
  </>
);
